import { Grid } from "@mui/material";
import { memo } from "react";
import { CustomFieldType, DefaultCustomFields } from "../enums";
import { useTranslation } from "react-i18next";
import ItemLabel from "../../components/ItemLabel/ItemLabel";


export const CustomFieldDetails = memo(({ customFieldData }) => {
    const { t } = useTranslation();
    const filteredData = customFieldData.filter((item) => !Object.values(DefaultCustomFields).includes(item.column))

    const showCustomValue = (data) => {
        if (data?.data_type === CustomFieldType.lookup) {
            const lookupText = data?.lookups.find((lookup) => data?.value == lookup?.value)?.text ?? "";
            return lookupText;
        } else if(data?.data_type === CustomFieldType.switch && data?.value) {
            return data.value === "1" ? t("Common.yes") : t("Common.no");
        }
        return data?.value
    }

    return (
        filteredData?.length > 0 && filteredData.map((item, index) => {
            const customFieldValue = showCustomValue(item);
            return <Grid item key={index}>
                {customFieldValue && <ItemLabel label={item.display_name} text={customFieldValue} />}
            </Grid>
        }))
})